module.exports = __webpack_public_path__ + "static/media/shell02.c5603fb6.jpg";